import { useEffect, useRef } from "react";

/**
 * Custom hook to handle click-outside behavior for tooltips
 * Closes the tooltip when clicking outside of the anchor element or tooltip content
 * 
 * @param {string|null} openTooltipId - The ID of the currently open tooltip (null if none)
 * @param {function} setOpenTooltipId - Function to set the open tooltip ID
 * @returns {React.RefObject} - Ref to attach to the tooltip anchor element
 */
export const useClickOutsideTooltip = (openTooltipId, setOpenTooltipId) => {
  const tooltipWrapperRef = useRef(null);

  useEffect(() => {
    if (!openTooltipId) return;

    const handleClickOutside = (e) => {
      if (!tooltipWrapperRef.current) return;
      const clickedInsideAnchor = tooltipWrapperRef.current.contains(e.target);
      const clickedInsideTooltip =
        typeof e.target?.closest === "function" &&
        (!!e.target.closest('.react-tooltip') || !!e.target.closest('[role="tooltip"]'));

      if (!clickedInsideAnchor && !clickedInsideTooltip) {
        setOpenTooltipId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openTooltipId, setOpenTooltipId]);

  return tooltipWrapperRef;
};

